import { ThemeOptions } from "@mui/material";

/**
 * Lloyds Banking Group (LBG) palette for the payer web app flow.
 *
 * Design language (from approved LBG designs):
 *  - Light-grey page background with white cards/inputs.
 *  - Solid black primary CTAs with white text; outlined black secondary CTAs.
 *  - Lloyds brand green (`success.main`) is used for the header bar and the
 *    illustrative status icons (coin, flag/tick, stopwatch).
 *  - Lloyds red (`error.main`) for the "payment uncertain" alert.
 *
 * NB: no `background.gradient` is set, so GlobalStyles falls back to the solid
 * `background.default` grey for the page body.
 */
const palette: Exclude<ThemeOptions["palette"], undefined> = {
  background: {
    default: "#EFEFEF",
    paper: "#FFFFFF",
  },
  primary: {
    main: "#000000",
    contrastText: "#FFFFFF",
  },
  secondary: {
    main: "#000000",
    contrastText: "#FFFFFF",
  },
  error: {
    main: "#D0021B",
  },
  info: {
    main: "#6E6E73",
  },
  warning: {
    main: "#6E6E73",
  },
  success: {
    main: "#10B981",
  },
  text: {
    primary: "#000000",
    secondary: "#000000",
  },
};

export default palette;
